export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  likes: number;
  comments: number;
  imageUrl: string;
  tags: string[];
  featured?: boolean;
}

export const articles: Article[] = [
  {
    slug: 'street-piano-dream',
    title: '从街头钢琴到万人舞台：一个普通上班族的音乐梦',
    excerpt: '他是一名普通的IT工程师，每天朝九晚五，却在周末的街头用一架旧钢琴弹奏着自己的音乐梦想。三年坚持，他终于站上了万人体育馆的舞台。',
    content: '<p>张伟是一名在互联网公司工作的普通程序员，每天面对代码和屏幕，过着朝九晚五的生活。但在每个周末的傍晚，他都会来到城市中心的步行街，坐在那架有些年头的公共钢琴前，弹奏起自己创作的旋律。</p><p>"音乐是我生活中不可或缺的一部分，"张伟说，"从大学开始自学钢琴，到现在已经坚持了十五年。虽然工作很忙，但音乐让我在繁忙的生活中找到了平衡。"</p><p>最初，路过的行人只是匆匆而过，偶尔有人驻足片刻。但随着时间推移，越来越多的人开始被他的琴声吸引。有人录下视频发到人人出彩平台，视频迅速获得了超过十万次的播放。</p><p>"我从来没有想过会有这么多人喜欢我的音乐，"张伟感慨道，"在人人出彩上，很多人给我留言鼓励，让我更加坚定了继续创作的信心。"</p><p>去年年底，张伟受邀参加了人人出彩举办的"普通人的高光时刻"年度盛典，在万人体育馆中演奏了自己的原创作品《城市之光》。当最后一个音符落下，全场观众起立鼓掌，那一刻，这个普通上班族的音乐梦想真正地绽放了。</p><p>"人人出彩让我明白，才华不需要惊天动地，只要敢于表达，就能找到共鸣。每个人的生命中都有一束光，关键是你要有勇气让它闪耀。"</p>',
    category: 'music',
    categoryName: '音乐',
    author: '编辑部',
    authorAvatar: '',
    date: '2026-08-05',
    readTime: '8分钟',
    likes: 3280,
    comments: 456,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20soft%20abstract%20piano%20keys%20with%20golden%20sunlight%20streaming%20through%20window%2C%20minimalist%20style%2C%20cream%20background%2C%20inspirational%20atmosphere%2C%20clean%20composition%20with%20subtle%20textures&width=640&height=400&seq=article-street-piano-dream-2026&orientation=landscape',
    tags: ['音乐梦想', '街头钢琴', '普通人故事', '坚持'],
    featured: true,
  },
  {
    slug: 'grandma-embroidery-art',
    title: '65岁奶奶的刺绣艺术：一针一线绣出精彩人生',
    excerpt: '退休在家的李奶奶，用一双巧手将传统刺绣与现代设计融合，在人人出彩平台上收获了超过10万粉丝，她的作品甚至被博物馆收藏。',
    content: '<p>今年65岁的李秀兰奶奶，退休前是一名纺织厂的女工。退休后的她，本可以和大多数同龄人一样跳跳广场舞、带带孙子，但她选择了一条不同寻常的路——重新拾起年轻时钟爱的刺绣手艺。</p><p>"我18岁进厂就开始接触刺绣，那时候每天要绣十几个小时，"李奶奶回忆道，"退休后闲不下来，就开始在家里绣着玩，没想到一发不可收拾。"</p><p>李奶奶的刺绣作品与众不同，她将传统的苏绣技法与现代设计理念相结合，绣出的花鸟鱼虫既保留了传统韵味，又充满了现代美感。她的孙子帮她将作品拍照上传到人人出彩平台后，很快就引起了大量关注。</p><p>"我真的没想到，我这个老太太绣的东西，会有这么多年轻人喜欢，"李奶奶笑着说，眼中闪烁着光芒，"每天看到那么多温暖的评论，我觉得自己活得比以前更有意思了。"</p><p>如今，李奶奶在人人出彩上拥有超过10万粉丝，她的刺绣作品被多家博物馆收藏，还受邀到多所大学进行讲座，向年轻人传授这门传统技艺。</p>',
    category: 'handcraft',
    categoryName: '手工',
    author: '编辑部',
    authorAvatar: '',
    date: '2026-08-03',
    readTime: '7分钟',
    likes: 5210,
    comments: 678,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20embroidery%20art%20scene%20with%20colorful%20threads%20and%20fabric%20texture%2C%20warm%20natural%20lighting%2C%20minimalist%20style%2C%20cream%20background%2C%20artistic%20composition&width=640&height=400&seq=article-grandma-embroidery-2026&orientation=landscape',
    tags: ['刺绣艺术', '传统文化', '奶奶故事', '手工艺'],
    featured: true,
  },
  {
    slug: 'small-town-photographer',
    title: '小镇青年的摄影之路：用镜头记录被遗忘的故乡',
    excerpt: '从大城市回到家乡小镇，他用相机记录下了即将消失的老街、老手艺和老人的面孔。这些照片在人人出彩上引发了无数人的乡愁共鸣。',
    content: '<p>刘强在上海做了五年摄影师，拍摄过无数光鲜亮丽的商业大片。但在去年，他做了一个让所有人意外的决定——辞掉高薪工作，回到位于安徽的家乡小镇。</p><p>"在上海的时候，我总是梦见小时候在老街上奔跑的场景，"刘强说，"当我得知家乡的老街即将拆迁改造时，我决定回来，用我的方式为这个即将消失的地方留下最后的影像。"</p><p>回到家乡后，刘强每天背着相机走街串巷，拍摄老街上晒太阳的老人、斑驳的墙面、冒着热气的老茶馆、傍晚时分在巷口下棋的邻居。每一张照片都是一个故事，每一帧画面都承载着几代人的记忆。</p><p>他将这些照片发布在人人出彩平台上，取名为《被遗忘的故乡》系列。没想到这组作品引发了巨大的反响，无数网友在评论区留言，分享自己关于故乡的记忆。</p><p>"很多人在评论区说，我的照片让他们想起了自己的家乡，想起了已经不在的亲人，"刘强动情地说，"这让我意识到，我拍摄的不只是一个即将消失的小镇，而是无数中国人心中的故乡。"</p>',
    category: 'photography',
    categoryName: '摄影',
    author: '编辑部',
    authorAvatar: '',
    date: '2026-07-28',
    readTime: '9分钟',
    likes: 4560,
    comments: 892,
    imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20abstract%20photography%20scene%20with%20old%20town%20alley%20and%20warm%20evening%20light%2C%20minimalist%20style%2C%20cream%20background%2C%20emotional%20atmosphere%2C%20clean%20composition&width=640&height=400&seq=article-small-town-photographer-2026&orientation=landscape',
    tags: ['摄影', '故乡记忆', '小镇故事', '乡愁'],
    featured: true,
  },
  {
    slug: 'deaf-dancer-miracle',
    title: '无声世界的舞者：她用身体创造了一个奇迹',
    excerpt: '从小失去听力的她，靠着感受地板震动学会了跳舞。在人人出彩的舞台上，她的一段现代舞视频感动了数百万人。',
    content: '<p>王晓月出生在一个普通的工人家庭，三岁时因为一场高烧失去了听力。但她并没有被命运击倒，反而在舞蹈中找到了与世界沟通的方式。</p><p>"我听不到音乐，但我能感受到震动，"晓月用手语表达着，"第一次站在舞蹈教室的木地板上，当音乐响起，地板传来的震动就像是我自己的心跳。那种感觉无法用语言形容。"</p><p>学习舞蹈对于听障人士来说异常艰难，晓月需要付出比常人多数倍的努力。她用手触摸音响来感受节奏，通过镜子观察每一个动作的细节，反复练习直到肌肉记住每一个舞步。</p><p>去年，她的舞蹈老师将她的一段现代舞视频上传到人人出彩平台。视频中，晓月身着白裙，在聚光灯下翩翩起舞，每一个动作都充满了力量与情感。这段视频迅速走红，获得了超过500万的播放量。</p><p>"我最想告诉大家的是，身体的限制并不可怕，真正可怕的是心灵的禁锢，"晓月写道，"哪怕生活在无声的世界里，我也要用舞蹈发出最响亮的声音。"</p>',
    category: 'dance',
    categoryName: '舞蹈',
    author: '编辑部',
    authorAvatar: '',
    date: '2026-07-25',
    readTime: '8分钟',
    likes: 12350,
    comments: 2340,
    imageUrl: 'https://readdy.ai/api/search-image?query=Graceful%20abstract%20dancer%20silhouette%20in%20flowing%20white%20dress%20with%20soft%20dramatic%20lighting%2C%20minimalist%20style%2C%20cream%20background%2C%20emotional%20atmosphere%2C%20artistic%20composition&width=640&height=400&seq=article-deaf-dancer-2026&orientation=landscape',
    tags: ['舞蹈', '听障', '励志故事', '无声世界'],
    featured: true,
  },
  {
    slug: 'coder-to-baker',
    title: '从代码到面团：一个程序员的面包店梦想',
    excerpt: '他辞去了年薪50万的程序员工作，在胡同里开了一家小小的面包店。用写代码的严谨对待烘焙，他的面包成了北京城里最温暖的味道。',
    content: '<p>陈浩曾是某知名互联网公司的高级工程师，年薪50万，过着让许多人羡慕的生活。但在他心里，一直藏着一个与代码无关的梦想——开一家属于自己的面包店。</p><p>"写代码和做面包其实很像，"陈浩笑着说，"都需要精确的配方和流程控制。调试程序和调整面包配方，都需要不断尝试和优化。"</p><p>三年前，陈浩做出了一个大胆的决定：辞职创业。他在北京东城的一条胡同里租下了一个小店面，取名"代码面包"。店里的每一款面包都有一个有趣的名字：Java可颂、Python法棍、C++肉桂卷……</p><p>创业初期并不顺利，连续几个月入不敷出。但陈浩没有放弃，他将自己的创业故事记录在人人出彩平台上，真诚的文字打动了许多人。越来越多的人慕名而来，不仅为了面包，更为了支持这个勇敢追梦的年轻人。</p><p>"我现在比写代码的时候累多了，但从来没有后悔过，"陈浩说，"每天早上闻到面包出炉的香味，看到顾客满足的笑容，那种幸福感是年薪50万也买不到的。"</p>',
    category: 'food',
    categoryName: '美食',
    author: '编辑部',
    authorAvatar: '',
    date: '2026-07-20',
    readTime: '7分钟',
    likes: 2850,
    comments: 534,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20bakery%20scene%20with%20fresh%20bread%20and%20soft%20morning%20light%2C%20minimalist%20style%2C%20cream%20background%2C%20homely%20atmosphere%2C%20clean%20composition&width=640&height=400&seq=article-coder-to-baker-2026&orientation=landscape',
    tags: ['美食', '创业故事', '面包店', '追梦'],
  },
  {
    slug: 'left-hand-painter',
    title: '左手画世界：一位残疾女孩的艺术奇迹',
    excerpt: '因为意外失去右手的她，用左手拿起画笔，画出了令人惊叹的世界。她的画作不仅美丽，更蕴含着生命的坚韧与希望。',
    content: '<p>赵小雨在18岁那年遭遇了一场车祸，失去了右臂。对于一个正在准备艺考的少女来说，这几乎是毁灭性的打击。她一度陷入深深的绝望，把自己关在房间里整整三个月。</p><p>"那段时间是我人生中最黑暗的日子，"小雨回忆道，"我觉得自己的人生已经完了，一个失去右手的人怎么可能继续画画？"</p><p>转机发生在一次偶然的机会。小雨的母亲给她买了一本左手书法的书，鼓励她尝试用左手写字和画画。起初非常困难，连一条直线都画不好。但小雨骨子里有一股不服输的韧劲，她每天练习八个小时以上，左手磨出了厚厚的茧。</p><p>两年后，小雨在人人出彩平台上发布了自己的第一组左手画作——《生命的另一面》。这些画作不仅技巧精湛，更蕴含着对生命的深刻感悟，迅速获得了大量关注和转发。</p><p>"失去右手让我学会了用不同的视角看世界，"小雨说，"我现在画的每一笔，都包含着对生命的感恩。如果我的故事能激励哪怕一个人，那我就觉得所有的努力都是值得的。"</p>',
    category: 'painting',
    categoryName: '绘画',
    author: '编辑部',
    authorAvatar: '',
    date: '2026-07-15',
    readTime: '9分钟',
    likes: 7890,
    comments: 1205,
    imageUrl: 'https://readdy.ai/api/search-image?query=Inspirational%20abstract%20painting%20scene%20with%20vibrant%20colors%20and%20brush%20strokes%2C%20warm%20natural%20lighting%2C%20minimalist%20style%2C%20cream%20background%2C%20emotional%20artistic%20composition&width=640&height=400&seq=article-left-hand-painter-2026&orientation=landscape',
    tags: ['绘画', '残疾', '励志', '左手画家'],
    featured: true,
  },
  {
    slug: 'night-school-poet',
    title: '夜校里的诗人：一个外卖骑手的文学梦',
    excerpt: '白天送外卖，晚上读夜校写诗。这个来自农村的90后骑手，用诗歌记录着城市的温度与孤独，在人人出彩上找到了属于自己的文学天地。',
    content: '<p>王志远今年28岁，来自河南农村，在北京做了三年外卖骑手。但很多人不知道的是，每天晚上脱下骑手服后，他会换上整洁的衬衫，去朝阳区的一所社区学院上文学课。</p><p>"我从小喜欢语文，但家里条件不好，高中没毕业就出来打工了，"志远说，"来北京后，发现社区学院有免费的成人教育课程，我就报了名。每周二四晚上七点到九点，雷打不动。"</p><p>志远的诗歌充满了对城市生活的敏锐观察：深夜写字楼里加班的灯光、清晨地铁里疲惫的面孔、雨中外卖箱上的水珠、老胡同里下棋的老人……他用朴素而真诚的语言，记录着这座城市的温度与孤独。</p><p>他将自己的诗作发布在人人出彩平台上，笔名"送餐诗人"。起初只有零星几个点赞，但他坚持每周更新。渐渐地，他的诗歌开始引起关注，有人评论说："你的诗让我看到了这座城市的另一面。"</p><p>"诗歌让我在这个忙碌的城市里找到了一种宁静，"志远说，"送外卖的时候，我在观察这个世界；写诗的时候，我在理解这个世界。人人出彩让我知道，哪怕是一个普通的外卖骑手，也可以有自己的文学梦。"</p>',
    category: 'writing',
    categoryName: '写作',
    author: '编辑部',
    authorAvatar: '',
    date: '2026-07-10',
    readTime: '8分钟',
    likes: 4120,
    comments: 687,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20poetry%20writing%20scene%20with%20notebook%20and%20city%20lights%20through%20window%2C%20minimalist%20style%2C%20cream%20background%2C%20literary%20atmosphere%2C%20clean%20composition&width=640&height=400&seq=article-night-school-poet-2026&orientation=landscape',
    tags: ['写作', '诗歌', '外卖骑手', '文学梦'],
  },
  {
    slug: 'ai-art-revolution',
    title: '当AI遇上传统国画：一个设计师的创新实验',
    excerpt: '他用AI技术辅助传统国画创作，在争议中坚持探索，最终开创了一种全新的艺术表达方式，让人人出彩的用户们大开眼界。',
    content: '<p>陈思远是一名90后数字艺术家，他的创作方式在传统艺术圈引起了不小的争议——他使用AI技术辅助传统国画创作。</p><p>"很多人说用AI画画不是真正的艺术，"陈思远说，"但我觉得，工具只是工具，关键是你想表达什么。就像当年的画家开始使用照相机辅助创作一样，AI也不过是一种新的创作工具。"</p><p>陈思远的工作流程很特别：他先用毛笔在宣纸上画出基础构图，然后将作品扫描到电脑中，使用AI工具进行色彩探索和构图优化，最后再根据AI的建议回到纸上进行最终的创作。这个过程中，AI只是提供灵感和参考，真正的创作决策始终由他完成。</p><p>他在人人出彩平台上分享了自己的创作过程和思考，引发了一场关于"科技与艺术"的激烈讨论。支持者认为这是艺术创新的方向，反对者则认为这背离了传统艺术的精神。</p><p>"争议是好事，说明这个领域还有很大的探索空间，"陈思远说，"我感谢人人出彩给了我这个平台，让我能和这么多有想法的人交流碰撞。无论你支持还是反对，这场对话本身就很有价值。"</p>',
    category: 'tech',
    categoryName: '科技',
    author: '编辑部',
    authorAvatar: '',
    date: '2026-07-05',
    readTime: '9分钟',
    likes: 3450,
    comments: 1230,
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20abstract%20scene%20blending%20traditional%20Chinese%20ink%20painting%20with%20digital%20elements%2C%20warm%20lighting%2C%20minimalist%20style%2C%20cream%20background%2C%20innovative%20atmosphere&width=640&height=400&seq=article-ai-art-2026&orientation=landscape',
    tags: ['科技', 'AI艺术', '国画', '创新'],
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  if (categorySlug === 'all') return articles;
  return articles.filter((a) => a.category === categorySlug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured);
}